import React, { Fragment } from 'react';
import { useTranslate, Show, TextField } from 'react-admin';
import { makeStyles, Typography } from '@material-ui/core';
import { LinkField, AmountHashField } from '../../components/fields';
import { GridShowLayout, Grid } from '../../components/wrapper';
import WalletAccountShowActions from './WalletAccountShowActions';
import WalletAccountItemList from '../walletAccountItems/WalletAccountItemList';
import AccountingAccountList from '../accountingAccounts/AccountingAccountList';

export const useStyles = makeStyles({
	aside: {
		minWidth: '25em',
		marginLeft: '1em'
	},
	titles: {
		marginTop: 10,
		marginBottom: 20
	},
	show: {
		marginBottom: 24
	},
	list: {
		marginBottom: 24
	}
});

const WalletAccountShow = props => {
	const translate = useTranslate();
	const classes = useStyles();
	return (
		<Fragment>
			<Show {...props} actions={<WalletAccountShowActions />} className={classes.show}>
				<GridShowLayout>
					<Grid container>
						<Grid item xs>
							<LinkField source="walletId" type="Wallet" />
							<TextField source="walletAccountId" />
							<TextField source="externalAccountId" />
							<TextField source="accountQualifier" />
							<TextField source="currency" />
							<TextField source="accountType" />
							<TextField source="accountStatus" />
							<TextField source="accountName" />
							<TextField source="accountDescription" />
						</Grid>
						<Grid item xs>
							<AmountHashField source="accountBalance" />
						</Grid>
					</Grid>
				</GridShowLayout>
			</Show>
			<Typography className={classes.titles} variant="h5">
				{translate('resources.walletAccountItems.name')}
			</Typography>
			<WalletAccountItemList
				perPage={5}
				{...props}
				basePath={'/walletAccountItems'}
				resource={'walletAccountItems'}
				title=" "
				filter={{ id: props.id }}
				className={classes.list}
			/>
			<Typography className={classes.titles} variant="h5">
				{translate('resources.accountingAccounts.name')}
			</Typography>
			<AccountingAccountList
				perPage={5}
				{...props}
				title=" "
				filter={{ ownerType: 'WalletAccount', ownerId: props.id }}
				basePath={'/accountingAccounts'}
				resource={'accountingAccounts'}
				className={classes.list}
			/>
		</Fragment>
	);
};

export default WalletAccountShow;
